module.exports = __webpack_public_path__ + "static/media/portada1366_768_ordenador_portatil_medio.30789dea.png";